import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISalesList } from "../../../Pages/Sales/ISales";

export const SalesSlicer = createSlice({
  name: "Sales",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISalesList[]>,
  reducers: {
    getSales: (state, _) => {
      state.isLoading = true;
    },
    successGetSales: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSales: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getSales, failureGetSales, successGetSales } =
  SalesSlicer.actions;

export default SalesSlicer.reducer;
